import React from 'react';
type Page = 'main' | 'privacy-policy' | 'terms-of-service';
export function Footer({
  onNavigate
}: {
  onNavigate?: (page: Page) => void;
}) {
  return <footer className="bg-white border-t border-gray-200 py-12 mt-auto" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-83">
        <div className="mb-6" data-id="element-84">
          <span className="text-xl font-bold tracking-tight text-gray-900" data-id="element-85">
            MCPGuard
          </span>
          <p className="mt-2 text-sm text-gray-500" data-id="element-86">
            Delegated authorization for AI systems.
          </p>
        </div>

        <div className="flex justify-center space-x-6 mb-8" data-id="element-87">
          <button onClick={() => onNavigate?.('privacy-policy')} className="text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-88">
            Privacy Policy
          </button>
          <button onClick={() => onNavigate?.('terms-of-service')} className="text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-89">
            Terms of Service
          </button>
          <a href="#early-access" className="text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-90">
            Contact
          </a>
        </div>

        <p className="text-xs text-gray-400" data-id="element-91">
          &copy; {new Date().getFullYear()} ProvenanceOne. All rights reserved.
        </p>
      </div>
    </footer>;
}